import {Tag} from "antd";
import React from "react";

export default function Status(props: any) {
    const status = props.status;
    return <>
        {status === 'active' ? (<Tag color="green">active</Tag>) : null}
        {status === 'inactive' ? (<Tag>inactive</Tag>) : null}
    </>
}